import { useState, useEffect } from 'react';
import "../css/nina.css";

export default function Nina() {

    const [choice, setChoice] = useState(null);
    const [activity, setActivity] = useState([]);
    const email = localStorage.getItem("inviteEmail");
    const [choiceList, setChoicesList] = useState([]);


    const isLocal = window.location.hostname === "localhost";
    const API_URL = isLocal ? "http://localhost:5000/api" // backend local sans /api 
        : "/api"; // backend prod avec /api

    //  Charger la liste au démarrage
    useEffect(() => {
        const fetchChoices = async () => {
            try {
                // const response = await fetch("/choices");
                const response = await fetch(`${API_URL}/choices`);
                if (!response.ok) {
                    console.error("Erreur lors du chargement des choix");
                    return;
                }
                const data = await response.json();
                setChoicesList(data);
                const existing = data.find(item => item.email === email);

                setChoice(existing);

            } catch (error) {
                //   setError("Impossible de récupérer la liste (serveur indisponible).");
            }
        };
        fetchChoices();
        // fetch("/api/choices")
        //   .then((res) => res.json())
        //   .then((data) => setChoicesList(data));


        const fetchActivity = async () => {
            try {
                // const response = await fetch("/choices");
                const response = await fetch(`${API_URL}/activities?email=${email}`);
                if (!response.ok) {
                    console.error("Erreur lors du chargement des choix");
                    return;
                }
                const data = await response.json();

                setActivity(data);

            } catch (error) {
                //   setError("Impossible de récupérer la liste (serveur indisponible).");
            }
        };
        fetchActivity();
    }, [API_URL, email]);

    return (
        <div>
            <h1>Résumé des invités au mariage</h1>

            <table>
                <thead>
                    <tr>
                        <th>Nom</th>
                        <th>Adultes</th>
                        <th>Enfants</th>
                        <th>Apporte</th>
                        <th></th>
                        <th>Boisson</th>
                        <th>Tâches</th>
                        {/* <th>Acitivité</th> */}
                    </tr>
                </thead>
                <tbody>
                    {choiceList && choiceList
                    .filter(item => item.details?.trim() || item.boisson?.trim())
                    .map((item) => (
                        <tr key={item.email}>
                            <td>{item.name}</td>
                            <td>{item.adultes}</td>
                            <td>{item.enfants}</td>
                            <td>{item.choice ? item.choice : "N/A"}</td>
                            <td>{item.details ?  item.details.split("\n").map((line, i) => (
                              <span key={i}>
                                {line}
                                <br />
                              </span>
                            )) : "N/A"}</td>
                            {/* <td>{item.details ? {item.details.split("\n").map((line, i) => (
                              <span key={i}>
                                {line}
                                <br />
                              </span>
                            ))}<span> : "N/A"}</td> */}
                            <td>{item.boisson ?  item.boisson.split("\n").map((line, i) => (
                              <span key={i}>
                                {line}
                                <br />
                              </span>
                            )) : "N/A"}</td>
                            <td>{item.services ? item.services.map((service) => <div key={service}>{service}</div>) : "Aucune tâche assignée"}</td>
                            {/* <td>{activity && `${activity.activity} - ${activity.activityDuration}` }</td> */}
                        </tr>
                    ))}
                    {/* <tr>
                        <td>{choice?.name || "N/A"}</td>
                        <td>{choice?.adultes ?? "N/A"}</td>
                        <td>{choice?.enfants ?? "N/A"}</td>
                        <td>{choice?.viande ? "Oui" : "Non"}</td>
                        <td>{choice?.choice ? `${choice.choice} : ${choice.details}` : "N/A"}</td>
                    </tr> */}
                </tbody>
            </table>
<div>
     {choiceList && choiceList.map((item) => (
                        <p key={item.email}>{item.email} - {item.name}</p>
                    ))}
</div>
        </div>
    );
}

